var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1114_5815",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 19,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.034 3H3V21H21.034V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1114_5815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2816 3.0237C17.8823 2.5623 22.7575 8.91808 20.4556 15.1679C17.9645 21.9312 8.78987 23.0824 4.63677 17.196C0.483662 11.3095 4.37546 3.50606 11.2816 3.0237ZM8.90494 7.18077C8.21001 7.24879 7.59161 7.88476 7.35468 8.51564C6.47044 10.8719 9.08462 13.7281 10.738 15.1254C12.0355 16.2216 14.2387 17.4884 15.9024 16.4693C16.4981 16.1043 17.1562 15.1492 16.6976 14.4695C16.5735 14.2859 15.4194 13.3251 15.1916 13.1755C14.4723 12.7028 13.3885 13.761 12.9696 14.3001C12.9209 14.3448 12.8687 14.346 12.8069 14.3329C12.5938 14.2893 11.6291 13.4549 11.4171 13.2577C10.9557 12.8286 10.3662 12.213 10 11.7046C9.91048 11.5799 9.64747 11.2387 9.68432 11.1026C9.69565 11.0618 10.2024 10.6237 10.2937 10.5211C10.678 10.0914 11.2102 9.37267 10.8231 8.80245C10.64 8.53264 9.82432 7.5356 9.59363 7.35875C9.3788 7.19437 9.17191 7.1547 8.90494 7.18077Z",
    fill: "#FF9355"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.45b10e61cf385d3be74c448c43e4a1cf.svg";
export { ForwardRef as ReactComponent };